import NameTokenInput, { NAME_TOKEN } from './NameTokenInput';

export { NAME_TOKEN };

export default NameTokenInput;
